import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/page-template.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Section = makeShortcode("Section");
const TranslatedTitle = makeShortcode("TranslatedTitle");
const ImageClipped = makeShortcode("ImageClipped");
const H1 = makeShortcode("H1");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Section mdxType="Section">
      <TranslatedTitle fr="Le sport" en="Training" mdxType="TranslatedTitle" />
      <ImageClipped maskStyle="circle" opacity={0.5} mdxType="ImageClipped">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "88.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAADkUlEQVQ4y11UXVNTVxS9tST3OyHkCyqBBCuEOFMHCkSifDUgUWDA2jEWkc4IYx+xdcYOD3WmFixFXpQPX1DbzlgCHVCoYvskaV+0/VGre+/khtSHPeeec/ZZZ+1z19qKoRvQNQ5dQuNQtbJQS6Ou6sU8A3zOcEYJEyaFomuU7AQdUjnc7sPxnSi/zCGhlwErvKG66XYHUA66ygAKa66KCskp5DmATuiHgDwxDbN0WCtjZui6HHj/yHuIx+MI+P1wu1w0PyIVFMrWDwENAvR6vKg9ehThUJjGWlSHqzEwMIDJyUnURepwKnkKiUQCFy9+htaWFnxQU4NEczP8VX54bJvIGBK2ZUmlSigUAkcsFkP6kzSSySTGxsawkctheHgYfX19mJqaku/uri58eOwYhoaG0NTYhOZ4M7EOSPh8PjTSmhKNRpHs6CAmSVy4MEZMPsUXxO7evUXMz8/hyZPHmJv7HsvLD7C4+CMmr15FR1s7Pr98GSMjIxg6fx69Pb04nTqNdDoNpb6uDoNnzxKjDTx//gxra6tYWVnGnTvf4emvT7H++BHuP7iPvd938cefr7D/ah9bv23h4cM1ybl7dx7nzmUwMTGBVGcKSkOsAYqioK2tDYvEaufZNnIEvrDwA33voL+/H7e+uYXXB6+xu7dLwHt4sf8CL/dfIreZw+rqCm7f/haZTAapFAFms5eQGRwUUH6LSzT/+ZefcJA/EDbZbBabW5vI/51H/q883vzzBm//fSsXbO9sY2lpCV9ev44zZ7pw8qOTUEZHR7FMJaY6OxEMBOCxbDTQD7rx1Q2sP1rH7OysXMBsN4T5Aqanp9Hd3Y14E0mpKkAO0tBCCjiROAHFot8diUTw9c2b8hcDJAfWltvlRuPx4/i4tZXkE6HvRgT9QTnMWuRclhXncT7vS8k2MWKRxugt+T1t04JN+uJ1V0VBxBXkEnGTuMqNUDCIaH29aLG3pwdT167hyvg4xq+MQ1HdGphldTgMX6VPBM6jVQT2er0EEJLDNSRqZtzR3i7PEqmtxczMjEgtFo2JlhXHl2wdjVnoesn0bEl2ErOt9FaKi+qJGa9bpgkfrfmrquTduQKVyhcvl4MyM2eNSxSvFjuL6lLlGRzvcjszihebhkXtS5qDcWhuzSj1vAKQ/r9OUv7t9FHugxaBST8kYMUSdENKsE2zZHae855VLM+23tkr7nNT8Ho8xbmB/wCa7idhyx8UQQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/c4865efb1ac9dee322314f64840d736a/8e964/thomas-morice-boxing.webp 150w", "/static/c4865efb1ac9dee322314f64840d736a/c85cb/thomas-morice-boxing.webp 300w", "/static/c4865efb1ac9dee322314f64840d736a/e88ff/thomas-morice-boxing.webp 600w", "/static/c4865efb1ac9dee322314f64840d736a/131f1/thomas-morice-boxing.webp 900w", "/static/c4865efb1ac9dee322314f64840d736a/92f8c/thomas-morice-boxing.webp 1200w", "/static/c4865efb1ac9dee322314f64840d736a/90ac6/thomas-morice-boxing.webp 2887w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/c4865efb1ac9dee322314f64840d736a/8a4e8/thomas-morice-boxing.png 150w", "/static/c4865efb1ac9dee322314f64840d736a/5a46d/thomas-morice-boxing.png 300w", "/static/c4865efb1ac9dee322314f64840d736a/0a47e/thomas-morice-boxing.png 600w", "/static/c4865efb1ac9dee322314f64840d736a/1cfc2/thomas-morice-boxing.png 900w", "/static/c4865efb1ac9dee322314f64840d736a/c1b63/thomas-morice-boxing.png 1200w", "/static/c4865efb1ac9dee322314f64840d736a/63ff0/thomas-morice-boxing.png 2887w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c4865efb1ac9dee322314f64840d736a/0a47e/thomas-morice-boxing.png",
                "alt": "Thomas morice gym boxing tennis crossfit",
                "title": "Thomas morice gym boxing tennis crossfit",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
    `}</span></p>
      </ImageClipped>
      <H1 mdxType="H1">My hobbies</H1>
    </Section>
    <Section mdxType="Section">
      <h2>{`Individual sports`}</h2>
      <p>{`I started sports at a very young age, first trained by my parents into tennis at the age of 5, I then discovered English boxing a little bit later, and I started competing in educational boxing with Saverne boxing club. Individual sports gave me a sense of responsibility and fighting spirit`}</p>
      <h2>{`Team sports`}</h2>
      <p>{`Very young I played football. I played it for four years, but then I gave up team sports for quite some time.`}</p>
      <p>{`Later, I felt the desire to join a sports team again, it was at the rugby club of Haguenau that I decided to practice this sport.
I learned a lot about team spirit and cohesion. In rugby more than in any other team sport, a team that does not work collectively and where commitment is at the service of the individual and not the collective has no chance of defeating its opponents.`}</p>
    </Section>
    <Section mdxType="Section">
      <TranslatedTitle fr="Les jeux" en="Games" mdxType="TranslatedTitle" />
      <ImageClipped maskStyle="polygon" opacity={0.25} mdxType="ImageClipped">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFDElEQVQ4y22TfVSOZxzH79J7KUNCx1tEpzcVKaIsVi0lSiotqdTWJE5T5lRsy2EmtDFkLH/EWJvXjoRVSK/P8/SusiOK2GSi95dtn11P5fhn1znf+3fd1znfz+973dd9SV19/XT3v9Pw+wBvevupfthCcfV9Gp+00vDoMYpK+bCqKpCX3abk0l4Usju0d/fRIzxKrzQMGvhfYE3TE0oE8MEIUP4WKCSXl1BaeJOqmipedXbRMzACVD66+voYriNAodfdvdQ+ekpJlUjYogQ2I6+QoRCSj0hRW0N1QyN/dXQK4OAwsLNXCesdUT+dvcMNhoGtFFXW0dD8lIYmkVBejkIhQyaXUSEvpPbuaarLrtP2uuMdsKOnT0B66RBSwt+qXQAbW55TXlPP/UctQ0CZrAxZeSnloiqKcsn7LoTcjF08e/mK3sG/h3xSe1cPHT0CKMDK+haoTPlbbQunb5RRL2B1vzeJdApq62q5V1xEztVfKLiUQf618zQ/ez60M6VfGvyXobjK76asQ0Ax7+vv42plMynn8ml8/ITaBw+5XZDDrdyLHP4mkQ2Bq7mX/SOlN87Q1v4a5ehUAssqannxqp3uwX94+aaDAdFAecrK8Wd7J8UV1RQU5tHU+oLUXZF8GubPkb3RrPVwJPdCOie+TaagVEZeSRmDwiOl7k+j5Y+X3C0sprBMQbmiktddnRw7cYTyhmby8rLwdbch/+4dDqUIYKgnX8QFstrDibQ9sbg527IjIQI7u5mEhQcjfRzow+XsHArycrh85QrnL2SLepYAf0fitsdwfG84bo6z2BkXwMa1S7GcMY7QFRYsWzCbpLhQvF2syDqbxofOJkwzkAQwyJ/de1LYnRyEsYEa/j5efJm4he2bPPH3mMfWUA+W289iY7BYjw/C3WE62zYsZMUSa47u20xMuA8Zh2Oxs5jICpc5SJ/HRpNxMh1f19k4z7PgTMYPtL1qIz7Kg82RQWyPWsZyO2OS4/xI3rISH1dL9sYtZbGtGfuS1uH5viXrvG2wMZuIk+U4pP27d6AoLyYuwomEmNChwyi6cRRHUy0+cJnP/oSlLLE2Yuf29SRGL8bOdAIBnhaYTtbHzcmUiboSFtPHMNd0EqudrZCSotfQ+qSe4yd2ErnWTfw6cC49HiMtifCQNRxM9GeyMAX4Lsfe3Ah9DQmzybrMeE8dexNDEsJ82R21htSt4ZzPzETKyxcXXJ5D2pEdOJlPoLLuPvtStqAlSSx0sMV9/lSm6I/CSEcVL3NDPpo3iW1+zhTfyibr5Pdcu3KZ2MgIbE1nMtV4CpKXwywy05OJWGfPTMNRLHK0ZvpYHcwNNbA31uLAJi+Oxazkq1X2nIpfz8EwLw4fOMSmmK3YWlqhr6mOmmiurSKhr6aCVHT9V47uCifE1QSnaTqsWmJLavwn7Fo0lvQoT25mnWVPsBuhrvY4WJphOFoXXfVRqAiIpoAYaGtioKPJaAHW01BHYmQormXy02d+Q/Om+jrCrIxwt56NtbkFuqNU0BBmDVUJPWEcraWOvoDoqaugI9bHaKkxYYwuU8ePRtri58upg2l8FRvLRi83DqUdwcFm7lB3JURTJNHX0hAQNZFAFV2xLQNRx+tpM8nElOkLXTFy9sFqmTeLQzYhzRSGOUJThJQHoSqkIWQgUhgIkL62hkilhqHBGIwFYK6TE2ZLvZm2YCXGntG4BMcSuCGOpISvufhzDv8BJwkWLL3ImpkAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/8e964/thomas-morice-games.webp 150w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/c85cb/thomas-morice-games.webp 300w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/e88ff/thomas-morice-games.webp 600w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/131f1/thomas-morice-games.webp 900w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/92f8c/thomas-morice-games.webp 1200w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/18fce/thomas-morice-games.webp 2377w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/8a4e8/thomas-morice-games.png 150w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/5a46d/thomas-morice-games.png 300w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/0a47e/thomas-morice-games.png 600w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/1cfc2/thomas-morice-games.png 900w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/c1b63/thomas-morice-games.png 1200w", "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/91cbd/thomas-morice-games.png 2377w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/98cb2ea6a55cd2c6ee6f5ff5ee22da8d/0a47e/thomas-morice-games.png",
                "alt": "Thomas morice video games chess",
                "title": "Thomas morice video games chess",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
    `}</span></p>
      </ImageClipped>
    </Section>
    <Section mdxType="Section">
      <p>{`Over time, I became less and less a game player. I nevertheless kept a child's soul, and I still play frequently. Register early in chess, it is not in this area that I was the most gifted I must admit.`}</p>
      <p>{`Quickly, video games took an important place in my life, and it was on one of the first opus of Medal of honor: Allied Assault that I spent most of my time, sometimes at the expense of my studies. However, thanks to this game, I really developed my English, playing with people online coming from throughout the world.`}</p>
      <p>{`After a quite serious back injury, and because I had to stay at home for quite some time, I played a lot of Fifa recently.`}</p>
    </Section>
    <Section mdxType="Section">
      <TranslatedTitle fr="Créer" en="Create" mdxType="TranslatedTitle" />
      <ImageClipped maskStyle="circle" opacity={0.4} mdxType="ImageClipped">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "88.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAExElEQVQ4yyWUV1CUVxTHL7toHF+Sh8yYh2QmZvIQS4yEBI1gGcVGRDECQrAgIiosAUSku6hoEKSIAmIBlLJSNIAIEZG6CEi1Y8EGIpjIIAomkzG/HMLD2XP3ft/93f/5nzOfUk4JKM88VEAZKqwGpb86FuH1aCXUzhqSm/vYVPQI5SPvmHlz4NABqHMnsSwG1dCDMvahfklCfbkCpdYdkz9FqMArqKDKsQiuQhMqcP8KzBJbSLrazSHjcz50iEVNdWWvsyOpbouxcPXDJOyUnBdGkIj6xlGAbqdFRblsVAu0SpQ1oCKaMNlzTdaNpDT3MynyKraGB+hiz/HFNCeCbOywnmuHraUNExyCUesjUdsPo+Z7CtDj7BgspE5yrZTbjHZfGyq0GZuzXYRW9aL8qtFEtHC0oRezFUEsn2OP/2IHnJZtQLkdRHnEo1aFoBYFjwJzx5QFC3CXgENFYVAdJgJObv6DT2I6xvZ3VLMo+xH6U+WsnmlP4nxHXH/yRe3JR20RK+bqUMv2CNBdFPpflkNV/2ftqErvClzy7qMreSx7dZjKhZpA8XSXkei6XlLcAtDPWIrNxt2opGpMAtIEmiWlnxTgpkwp6XdRUI7Gt1QAV5gYWkdSYz8fhYvqADmwQy7aKc3yN7LkYCk3Sy6w33wR03Xi29FKsUOa6ncJtUHAar386IrR+FxEeV0QT0rZlneHLdmtspYx8a3EVFeI1lcuDWzC29GFJ/nHyIuL5YOgdFS8iNDLM2/JLscF6JyCZrQxWwuZuPU0+vRMep510luXQHJaLJP8xaOt8rLPFWZti6fA3oIyt6XUXGtjXIpUsE+e7xwVU4xyTkZpHEX2xizGb8mmqiAC/mzkrwcX4ZoMb40X3Tl27PL3YPOa9RjWWlG4djYnbM2JLKrFo1aG3TcTrVehdFrADomicLW0fF0mmbEu0KCnr7OGkTwbRgyLeZWxSPIS3ufbctllCmkrzClaORWd13ZUxkOO3epncoj455aLZosBtSYOZWIXRcL+TfydPoPuxmyGynQMp5sznLOQ1+mWvMpeybu2ePqz7Sl0mcnJVd/xaYJ4e/wOVkX3iSi+Lc3IFqDYtjoalaO35nXqVzw7v53+9lxeHDFnMGMBw1kLeXtmLu+KnBhpPcw/HVF06b/HyV3m7dQ9xqfK8O+tZPf5DqyiKlCOqWh+1KNuRc2gM96MnmYDLVFLKN7wGW/TLBg6acGb42aMlG5muDmGf9t+pTHZAdN4UZf7AJV5E3W4gY8DzxF5QdZOKSjrQFRT2GRelQbwvKUEHzdXjsSE877Cizfl/gxe9ONN63EGOn+Du2fIarrE9PqXzGnvx6L9JbPb+vjc0MZh42Pc4uSiWV6o07ppBEQn4nmihp+Ta7ly2UBPWRythlgGG47y6kYBI49r6Ohqxv3hW7weDqJ7NIh3l8T1fnQtz/G5P8CKwnbUD9KsCbPXoSz95UsRLpJDqI22oC9+CrcjpjCU+jUDOcuhcS8bjfJFMr6QeDYWJVK24QYqrQmVL7noJhrHMBmbmU6MmydGW+v51lnHkxRz+tKsGDgzj/60BQylWXK9LIyJ9U9R9d2YGp+iLbmHtuAu2px2tKeMaDMa0Jxrx8Qzmv8A7WhyVqjiBrgAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/dd4a98291ccb753f7dbf2a9f9925031b/8e964/thomas-morice-be-creative.webp 150w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/c85cb/thomas-morice-be-creative.webp 300w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/e88ff/thomas-morice-be-creative.webp 600w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/131f1/thomas-morice-be-creative.webp 900w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/92f8c/thomas-morice-be-creative.webp 1200w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/90ac6/thomas-morice-be-creative.webp 2887w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/dd4a98291ccb753f7dbf2a9f9925031b/8a4e8/thomas-morice-be-creative.png 150w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/5a46d/thomas-morice-be-creative.png 300w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/0a47e/thomas-morice-be-creative.png 600w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/1cfc2/thomas-morice-be-creative.png 900w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/c1b63/thomas-morice-be-creative.png 1200w", "/static/dd4a98291ccb753f7dbf2a9f9925031b/63ff0/thomas-morice-be-creative.png 2887w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/dd4a98291ccb753f7dbf2a9f9925031b/0a47e/thomas-morice-be-creative.png",
                "alt": "Thomas morice creative figma design",
                "title": "Thomas morice creative figma design",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
    `}</span></p>
      </ImageClipped>
    </Section>
    <Section mdxType="Section">
      <p>{`I increasingly enjoy working with my creativity. We develop a lot of logic in programming, but from time to time I feel the need to let my imagination run free.`}</p>
      <p>{`It is the case when I create design. Playing with colors, shapes and typologies gives my mind some rest. The site you are currently viewing was first designed using the figma tool.`}</p>
      <p>{`It is also a way for me to practice pixel-perfect implementation, in order to stick as closely as possible to design when I work with a designer.`}</p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      